import React from "react";
import { Button, Card, Typography } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import SiteFooter from "../components/SiteFooter";

const { Title, Paragraph, Text } = Typography;

const agreementSections = [
    ["一、服务说明", "“看屋子”由深圳市正士吉商贸有限责任公司运营，为房东、租户及经授权的管理人员提供房源展示、租住申请、合同资料管理、站内消息、入住工单等信息服务。平台不代替用户作出交易决定，实际租赁权利义务以双方依法签订的合同为准。"],
    ["二、账号注册与使用", "用户应提供真实、准确、合法的信息，妥善保管账号和密码，并对账号下的操作负责。不得冒用他人身份、出租或出借账号，也不得利用平台发布违法、虚假、侵权或与房屋租赁无关的信息。"],
    ["三、房源与交易信息", "房东应确保发布房源的权属或管理授权真实有效，房源价格、状态、图片和费用信息准确。租户应自行核验房源和合同。平台有权对涉嫌违法、虚假、重复或侵权的信息采取下架、限制展示或封禁账号等措施。"],
    ["四、文件与沟通", "用户上传的合同、证件、居住登记和工单资料应与服务目的相关并具备合法来源。站内消息和工单回复会作为服务过程记录，请勿发送银行卡密码、短信验证码等敏感信息。"],
    ["五、服务变更与中断", "平台会尽力保障服务连续与数据安全；因网络故障、维护升级、不可抗力或第三方服务异常导致短时中断时，平台将在合理范围内及时处理。重大功能变更将通过页面提示等方式告知。"],
    ["六、账号注销", "用户可在账号菜单中提交注销申请。存在在租关系时需先完成退租或妥善处理租住关系。注销申请受理后账号将停用；依法应留存的合同、交易、安全日志等信息将在法定期限内隔离保存，到期后删除或匿名化。"],
    ["七、争议处理", "本协议适用中华人民共和国法律。因使用本服务发生争议，双方应先友好协商；协商不成的，可依法向运营主体所在地有管辖权的人民法院提起诉讼。"]
];

const privacySections = [
    ["一、我们收集的信息", "为提供账号、房源、租住、消息和工单服务，我们可能收集用户名、手机号、微信号，以及用户主动提交的房屋、租住、合同、证件图片、居住登记、消息和工单内容。系统还会记录必要的登录时间、操作日志和设备网络信息，用于安全审计与故障排查。"],
    ["二、信息使用目的", "上述信息仅用于身份识别、展示和管理房源、建立租住关系、传递双方消息、处理工单、保障账号与系统安全、履行法律义务以及改进服务。未经同意，我们不会将个人信息用于无关目的。"],
    ["三、共享与公开", "公共池仅展示出租所需的房源信息；合同、证件和居住登记等隐私文件仅向具备相应权限的用户提供。除获得授权、完成用户选择的服务所必需，或法律法规及监管机关要求外，我们不会向无关第三方提供个人信息。"],
    ["四、保存与安全", "数据原则上存储在中华人民共和国境内。我们采取访问权限控制、密码加密、登录保护、传输加密和定期备份等措施。保存期限以实现服务目的和履行法定义务所需的最短期限为原则；期限届满后删除或匿名化。"],
    ["五、您的权利", "用户可查看或更正账号及业务信息，可删除自己有权管理的内容，并可从账号菜单提交注销申请。因合同履行、争议解决或法律要求暂不能删除的信息，我们会限制其继续使用。"],
    ["六、未成年人保护", "本服务主要面向具备完全民事行为能力的房屋租赁参与者。未成年人使用服务应取得监护人同意，并在监护人指导下提交个人信息。"],
    ["七、政策更新与联系", "本政策更新时会通过页面提示等合理方式告知。对个人信息处理有疑问、投诉或权利请求，可通过平台内消息联系运营方深圳市正士吉商贸有限责任公司，我们将在核验身份后处理。"]
];

const LegalScreen = ({ type }) => {
    const navigate = useNavigate();
    const isPrivacy = type === "privacy";
    const sections = isPrivacy ? privacySections : agreementSections;
    return (
        <div className="legal-page">
            <div className="legal-header">
                <Button type="text" icon={<LeftOutlined />} onClick={() => navigate(-1)}>返回</Button>
                <Text strong>看屋子</Text>
            </div>
            <Card className="legal-card">
                <Title level={2}>{isPrivacy ? "看屋子隐私政策" : "看屋子用户服务协议"}</Title>
                <Paragraph type="secondary">运营主体：深圳市正士吉商贸有限责任公司</Paragraph>
                <Paragraph type="secondary">更新及生效日期：2026年9月9日</Paragraph>
                <Paragraph>欢迎使用看屋子。请在使用本服务前认真阅读本文件；注册、登录或继续使用服务，即表示您已理解并同意相应内容。</Paragraph>
                {sections.map(([title, content]) => <section key={title}><Title level={4}>{title}</Title><Paragraph>{content}</Paragraph></section>)}
            </Card>
            <SiteFooter compact />
        </div>
    );
};

export default LegalScreen;
